// CapCondition Messages
import { defineMessages } from 'react-intl';

export const scope = 'components.CapCondition';

export default defineMessages({
  selectPossibleValue: {
    id: `${scope}.selectPossibleValue`,
    defaultMessage: 'Select possible values',
  },
  searchPossibleValue: {
    id: `${scope}.searchPossibleValue`,
    defaultMessage: 'Search possible values',
  },
  maxPossibleValues: {
    id: `${scope}.maxPossibleValues`,
    defaultMessage: 'Only 15 values can be selected',
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: 'title',
  },
  selectTriggerEventAttribute: {
    id: `${scope}.selectTriggerEventAttribute`,
    defaultMessage: 'Select trigger event attribute',
  },
  entryTriggerEventAttribute: {
    id: `${scope}.entryTriggerEventAttribute`,
    defaultMessage: 'Entry trigger event attribute',
  },
});
